import { useQuery } from '@tanstack/react-query';
import BillingService from '../Services/billing/BillingService';
export const LIST_PLANS_QUERY_KEY = 'listPlans';
export const SUBSCRIPTION_STATUS_QUERY_KEY = 'subscriptionStatus';

export const useGetPlans = () => {
  // Wrap the queryFn in a promise for toast
  // const queryFnWithToast = async () => {
  //   return await toast.promise(
  //     BillingService.listPlans(),
  //     {
  //       loading: 'Chargement des offres...',
  //       success: (data) => {
  //         if (data.success && Array.isArray(data.plans)) {
  //           return `${data.plans.length} offre(s) chargée(s)`;
  //         }
  //         return 'Offres chargées';
  //       },
  //       error: 'Erreur lors du chargement des offres',
  //     }
  //   );
  // };
  return useQuery({
    queryKey: [LIST_PLANS_QUERY_KEY],
    queryFn: () => BillingService.listPlans(),
    staleTime: 5 * 60 * 1000, // 5 minutes, reduced from 5 hours to refresh more often during dev
    cacheTime: 10 * 60 * 1000, // 10 minutes
    retry: 2, // Retry failed requests twice
    refetchOnWindowFocus: false, // Don't refetch when window gains focus
    onError: (error) => {
      console.error("Error fetching plans:", error);
    }
  });
};

export const useGetSubscriptionStatus = () => {
  return useQuery({
    queryKey: [SUBSCRIPTION_STATUS_QUERY_KEY],
    queryFn: () => BillingService.getSubscriptionStatus(),
    staleTime: 5 * 60 * 1000, 
    cacheTime: 10 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: true,
    onError: (error) => {
      console.error("Error fetching subscription status:", error);
    }
  });
}; 